export default function DateField({
  field,
  value = "",
  onChange,
  error,
  disabled,
}) {
  return (
    <div className="dynamic-field-control">
      <label className="dynamic-field-control__label" htmlFor={field.key}>
        {field.label}
        {field.required && (
          <span className="dynamic-field-control__required">*</span>
        )}
      </label>

      <input
        id={field.key}
        type="date"
        value={value || ""}
        disabled={disabled}
        className={`dynamic-field-control__input ${
          error ? "dynamic-field-control__input--error" : ""
        }`}
        onChange={(e) => onChange(field.key, e.target.value)}
      />

      {error && <span className="dynamic-field-control__error">{error}</span>}
    </div>
  );
}
